import { lazy, Suspense, Component } from 'react';
import AsyncComponentLoading from './AsyncComponentLoading';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { BlankIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = props => {
  return /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    LoadingIndicator: /*#__PURE__*/_jsx(SkeletonCircle, {})
  }, props));
};
LoadingComponent.displayName = 'AsyncUIAvatarLoading';
const SmallerLoadingComponent = props => {
  return /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    LoadingIndicator: /*#__PURE__*/_jsx(SkeletonCircle, {
      size: 25
    })
  }, props));
};
SmallerLoadingComponent.displayName = 'AsyncUIAvatarLoading';
const ErrorComponent = () => /*#__PURE__*/_jsx(IconCircle, {
  icon: BlankIcon,
  backgroundColor: "fill-tertiary-default",
  borderWidth: "0",
  size: "100"
});
ErrorComponent.displayName = 'AsyncUIAvatarError';
const Avatar = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "async-avatar-components" */'avatar-components/Avatar').then(module => ({
  default: module.Avatar
})));
class AsyncUIAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error) {
    this.setState({
      hasError: true
    });
    setTimeout(() => {
      throw error;
    }, 0);
  }
  render() {
    return this.state.hasError ? /*#__PURE__*/_jsx(ErrorComponent, {}) : /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(LoadingComponent, {}),
      children: /*#__PURE__*/_jsx(Avatar, Object.assign({}, this.props))
    });
  }
}
AsyncUIAvatar.displayName = 'AsyncUIAvatar';
/**
 * This `AsyncUIAvatar` has a smaller loading component - this is used for the
 * ThreadListMember rows since the rendered avatar is smaller than default
 */ // eslint-disable-next-line react/no-multi-comp
export class SmallerAsyncUIAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error) {
    this.setState({
      hasError: true
    });
    setTimeout(() => {
      throw error;
    }, 0);
  }
  render() {
    return this.state.hasError ? /*#__PURE__*/_jsx(ErrorComponent, {}) : /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(SmallerLoadingComponent, {}),
      children: /*#__PURE__*/_jsx(Avatar, Object.assign({}, this.props))
    });
  }
}
SmallerAsyncUIAvatar.displayName = 'SmallerAsyncUIAvatar';
export default AsyncUIAvatar;